import { FilterActions } from "~/types/actions.enum";
import { TFiltersAction, TFiltersState } from "./filters.state";

// ✅ Filters reducer logic
export const filtersReducer = (state: TFiltersState, action: TFiltersAction): TFiltersState => {
    switch (action.type) {
        case FilterActions.SET_COMPANIES_DATA: {
            return {
                ...state,
                companies: action.payload
            };
        }

        case FilterActions.SET_INDUSTRIES_DATA: {
            return {
                ...state,
                industries: action.payload
            };
        }

        case FilterActions.SET_YEAR_FILTERS: {
            return {
                ...state,
                yearFilters: action.payload
            };
        }

        case FilterActions.SET_INDUSTRY_FILTERS: {
            return {
                ...state,
                industryFilters: action.payload
            };
        }

        case FilterActions.SET_COMPANY_FILTERS: {
            return {
                ...state,
                companyFilters: action.payload
            };
        }

        case FilterActions.SET_IS_LOADING_YEARS: {
            return {
                ...state,
                isLoadingYearFilters: action.payload
            };
        }

        case FilterActions.SET_IS_LOADING_INDUSTRIES: {
            return {
                ...state,
                isLoadingIndustryFilters: action.payload
            };
        }

        case FilterActions.SET_IS_LOADING_COMPANIES: {
            return {
                ...state,
                isLoadingCompanyFilters: action.payload
            };
        }

        default:
            return state;
    }
};
